<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Asignar Jefatura y Retroalimentación",
            items: [
                {
                    text: "Utility",
                    href: "/"
                },
                {
                    text: "Starter Page",
                    active: true
                }
            ],
            filtro:{
                colegio:''
            },
            colegios:[],
            usuarios:[],
            funcionarios:[]
        };
    },
    methods: {
        actualizar(){
            if (this.user.rol_id==1) {
                axios.get('/api/get_colegios').then(res=>{
                    this.colegios = res.data.colegios;
                });
            }
            else if (this.user.rol_id==2) {
                this.filtro.colegio=this.user.colegio_id;
                this.buscar();
            }
        },
        buscar(){
            axios.get('/api/get_usuarios_instrumentos/'+this.filtro.colegio).then(res=> {
                if(res.data.estado){
                    this.usuarios = res.data.usuarios
                    //console.table(this.Usuarios);
                }
            });
            axios.get('/api/get_personas_colegio/'+this.filtro.colegio).then(res=>{
                this.funcionarios = res.data.users;
            });
        },
        actualizar_jefatura(data){
            //console.log(data);
            axios.post('/api/asignar_jefatura_evaluador',data).then(res=> {
                if(res.data.estado){
                    Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: res.data.mensaje,
                    showConfirmButton: false,
                    timer: 1500
                    })
                    //console.log(res.data.mensaje);
                }
            
            })
        },
        actualizar_retroalimentacion(data){
            axios.post('/api/asignar_retroalimentacion_evaluador',data).then(res=> {
                if(res.data.estado){
                    Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: res.data.mensaje,
                    showConfirmButton: false,
                    timer: 1500
                    })//console.log(res.data.mensaje);
                }
            
            })
        },
    },
    created(){
        this.actualizar();
    } 
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <b-button class="float-right ml-2" variant="primary" href="/app/agregar/usuarios">Usuarios</b-button>
                            </div>
                        </div>
                        <div class="card p-3 mt-2 bg-soft-primary" v-if="user.rol_id==1">
                            <div class="row">
                                <div class="offset-md-2 col-md-6">
                                    <div class="form-group row">
                                        <label class="col-md-3 pt-1 font-size-16 text-right">Colegio :</label>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="filtro.colegio" @change="buscar()">
                                                <option disabled value="">Seleccione colegio</option>
                                                <option v-for="colegio in colegios" :key="colegio.id" :value="colegio.id">{{colegio.nombre.toUpperCase()}} ({{colegio.comuna_nombre}} - {{colegio.region_nombre}})</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 text-right">
                                    <b-button variant="primary" block @click="buscar()">Buscar</b-button>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th>Nº</th>
                                                <th>Nombre </th>
                                                <th>Rut</th>
                                                <th>Instrumento</th>
                                                <th>Jefe</th>
                                                <th>Retroalimentación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(usuario,index ) in usuarios" :key="index">
                                                <th>{{index+1}}</th>
                                                <td>{{usuario.nombre}} {{usuario.apellidoPaterno}} {{usuario.apellidoMaterno}}</td>
                                                <td>{{usuario.rut}}-{{usuario.rut_dv}}</td>
                                                <td>{{usuario.datainstrumento.nombre}}</td>
                                                <td>
                                                    <select class="custom-select" v-model="usuario.jefe_id" @change="actualizar_jefatura(usuario)">
                                                        <option selected value="null">Seleccione jefe</option>
                                                        <option v-for="funcionario in funcionarios" :key="funcionario.id" :value="funcionario.id" >{{funcionario.nombre}} {{funcionario.apellidoPaterno}} {{funcionario.apellidoMaterno}}</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <select class="custom-select" v-model="usuario.retro_id" @change="actualizar_retroalimentacion(usuario)">
                                                        <option selected value="null">Seleccione retroalimentación</option>
                                                        <option v-for="funcionario in funcionarios" :key="funcionario.id" :value="funcionario.id">{{funcionario.nombre}} {{funcionario.apellidoPaterno}} {{funcionario.apellidoMaterno}}</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>